module.exports = __webpack_public_path__ + "img/whatsapp-logo.438d2f56.svg";